import { render, staticRenderFns } from "./customTinyMceAdaptiveImageBlock.vue?vue&type=template&id=361a13b7&"
import script from "./customTinyMceAdaptiveImageBlock.vue?vue&type=script&lang=js&"
export * from "./customTinyMceAdaptiveImageBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports